import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { GtStripeService } from '../../services/gt-stripe.service';
import { STATES } from '../../constants/state-abbreviations';
import { SessionService } from '../../services/session.service';


@Component({
    selector: 'stripe-add-terminal-location-modal',
    templateUrl: './stripe-add-terminal-location-modal.component.html',
    styleUrl: './stripe-add-terminal-location-modal.component.scss',
    standalone: false
})

export class StripeAddTerminalLocationModalComponent extends BaseModalComponent{
  public allStates = STATES;

  public form = new FormGroup({
    displayName: new FormControl('', {
      validators: Validators.required
    }),
    address1: new FormControl('', {
      validators: Validators.required
    }),
    address2: new FormControl(),
    city: new FormControl('', {
      validators: Validators.required
    }),
    postalCode: new FormControl('', {
      validators: Validators.required
    }),
    state: new FormControl('', {
      validators: Validators.required
    }),
    country: new FormControl('US'),
  });
  
  constructor(public dialogRef: MatDialogRef<StripeAddTerminalLocationModalComponent>,
    private stripeService: GtStripeService,
    private sessionService: SessionService){
    super();
  }

  onSubmit({value, valid}){
    if(valid){
      this.isLoading = true;
      let data = {
        display_name: value.displayName,
        address: {
          city: value.city,
          country: value.country,
          line1: value.address1,
          line2: value.address2,
          postal_code: value.postalCode,
          state: value.state
        }
      };
      this.stripeService.createTerminalLocation(this.sessionService.getUser().stripeAccountId, data).subscribe(result =>{
        if(result !== null){
          this.dialogRef.close({status: 'success', message: 'Successfully registered Terminal Reader'});
        }
        this.isLoading = false;
      },err => {
        console.log(err);
        this.dialogRef.close({status: 'failed', message: err.error});
        this.isLoading = false;
      });
    }
  }

}
